import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationOffersScreens,
  simulationPrivateCdcPayrollScreen,
} from '@/modules/simulation/route';
import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Consignado privado CDC no caminho do legado com o rótulo padrão (`router.tsx:1134-1144`,
// `resource='ConsignadoPrivado'` com o CDC pela URL, useIsCDC.ts:7-15): sem hub; o passo vai em `?passo=`.
export const Route = createFileRoute('/_app/ccb/contratar/consignado-privado-cdc/')({
  validateSearch: flowSearchSchema(),
  staticData: { screen: simulationPrivateCdcPayrollScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationOffersScreens, 'PrivateCdcPayrollRouteScreen'),
});
